import React from 'react';

export const SbSharedRefineMenuShippingFiltersWrapperLazy = React.lazy(() =>
    import(
        /* webpackChunkName: "SbSharedRefineMenuShippingFilters" */ '../SbSharedRefineMenuShippingFilters/SbSharedRefineMenuShippingFiltersWrapper'
    )
);
